/* ============================================================
   GOB Club motion (V149, 18 Oct 2026) - "Gentle roll" (option 03).
   The PDP prices change with one quiet step when the Club card is switched.

   1. Optimistic: html.gob-club-on flips the moment the card is tapped,
      not ~1.6s later when the cart round trip ends. gob-club-toggle.js
      still does the cart work and decides the truth; if it fails, the
      class is re-read from the cart (GOBClubPrices.read) and flips back.
   2. Roll: just before the flip, a frozen copy ("ghost") of each price that
      is leaving is laid exactly over it. Switching ON the old prices drift
      up 8px and fade while the member prices rise into place from 8px
      below; switching OFF is the mirror (member prices drift down, regular
      prices settle in from above). The versions follow 90ms apart.
   3. Glide: the price area grows/shrinks over .75s so the card under the
      finger slides instead of jumping (19px desktop, ~50px phone).
   Nothing moves with prefers-reduced-motion: the switch is instant.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gcm) return; window.__gcm = 1;
  var root = document.documentElement;
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var DY = 8, OUT_MS = 420, STAGGER = 90, GLIDE = '.75s cubic-bezier(.25,.1,.25,1)', GLIDE_MS = 750, HOLD = 1800, timer = null;

  /* ---------- 1. tap: ghosts, optimistic flip, glide ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target && e.target.closest && e.target.closest('[data-gcc] [data-club-toggle]');
    if (!h || h.classList.contains('is-busy')) return;
    setTimeout(function () {                      /* after the card's own handler has flipped .on */
      var box = h.closest('.gcc-box');
      if (!box || !window.GOBClubPrices) return;
      var on = box.classList.contains('on');
      if (root.classList.contains('gob-club-on') === on) return;
      var card = box.closest('[data-gcc]'), before = card.getBoundingClientRect().top;
      var gs = RM.matches ? [] : ghosts(on);
      GOBClubPrices.set(on);                      /* fires gob:club-prices -> run() */
      pin(gs);                                    /* the flip resizes the version price boxes: keep each ghost where its price was */
      if (!RM.matches) glide(on, card.getBoundingClientRect().top - before);
    }, 0);
  }, true);

  /* ---------- ghosts: frozen copies of the prices that are leaving ---------- */
  function host(el) {                             /* .d-prow is display:contents: skip such boxes */
    var a = el.parentElement;
    while (a && getComputedStyle(a).display === 'contents') a = a.parentElement;
    return a;
  }
  function strip(n) {                             /* a ghost must never be found by other scripts */
    [n].concat([].slice.call(n.querySelectorAll('*'))).forEach(function (x) {
      [].slice.call(x.attributes).forEach(function (at) {
        if (at.name === 'id' || at.name === 'name' || at.name === 'for' || at.name === 'form' || at.name.indexOf('data-') === 0) x.removeAttribute(at.name);
      });
    });
  }
  /* Some layout rules depend on html.gob-club-on (e.g. the versions' member price is a
     flex column only while it is on). The flip happens right after the ghost is made, so
     freeze the computed layout of the copy and its children inline. */
  var FREEZE = ['display', 'flex-direction', 'flex-wrap', 'align-items', 'justify-content', 'row-gap', 'column-gap',
    'text-align', 'white-space', 'font-size', 'font-weight', 'line-height', 'color', 'text-decoration-line'];
  function freeze(src, dst) {
    var a = [src].concat([].slice.call(src.querySelectorAll('*'))), b = [dst].concat([].slice.call(dst.querySelectorAll('*')));
    for (var i = 0; i < a.length && i < b.length; i++) {
      var cs = getComputedStyle(a[i]);
      for (var k = 0; k < FREEZE.length; k++) b[i].style.setProperty(FREEZE[k], cs.getPropertyValue(FREEZE[k]), 'important');
    }
  }
  function ghost(el, dy, delay) {
    if (!el || !el.offsetParent) return;
    var a = host(el); if (!a) return;
    var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
    if (!r.width || !r.height) return;
    if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
    var c = el.cloneNode(true); freeze(el, c); strip(c);
    c.classList.add('gcm-ghost'); c.setAttribute('aria-hidden', 'true');
    var s = c.style;
    s.setProperty('display', cs.display === 'none' ? 'block' : cs.display, 'important');
    s.position = 'absolute'; s.margin = '0'; s.gridArea = 'auto'; s.boxSizing = 'border-box';
    s.width = r.width + 'px'; s.height = r.height + 'px'; s.pointerEvents = 'none'; s.zIndex = '2';
    var ar = a.getBoundingClientRect();
    s.left = (r.left - ar.left - a.clientLeft) + 'px'; s.top = (r.top - ar.top - a.clientTop) + 'px';
    a.appendChild(c);
    var cr = c.getBoundingClientRect();         /* correct any containing-block offset to the pixel */
    s.left = (parseFloat(s.left) + r.left - cr.left) + 'px'; s.top = (parseFloat(s.top) + r.top - cr.top) + 'px';
    if (!c.animate) { c.remove(); return; }
    c.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(' + dy + 'px)' }],
      { duration: OUT_MS, delay: delay || 0, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' }).onfinish = function () { c.remove(); };
    return { c: c, r: r };
  }
  function ghosts(on) {
    var dy = on ? -DY : DY, out = [];             /* on: old prices drift up; off: member prices drift down */
    out.push(ghost(document.querySelector(on ? '.d-pricearea .d-pl' : '.d-pricearea .gob-mp--guest'), dy, 0));
    document.querySelectorAll(on ? '.gobd1 .d-v .d-p__off' : '.gobd1 .d-v .d-p__on').forEach(function (e, i) { out.push(ghost(e, dy, i * STAGGER)); });
    return out.filter(Boolean);
  }
  function pin(gs) {
    gs.forEach(function (g) {
      var cr = g.c.getBoundingClientRect(), s = g.c.style;
      s.left = (parseFloat(s.left) + g.r.left - cr.left) + 'px'; s.top = (parseFloat(s.top) + g.r.top - cr.top) + 'px';
    });
  }

  /* ---------- glide ---------- */
  function glide(on, delta) {
    if (Math.abs(delta) < 2) return;
    var el = document.querySelector(on ? '.d-pricearea .gob-mp--guest' : '.d-pricearea .d-pl');
    if (!el || !el.offsetParent) return;
    var H = el.offsetHeight, st = el.style;
    if (on) { st.height = Math.max(0, H - delta) + 'px'; st.overflow = 'clip'; st.overflowClipMargin = '6px'; }
    else { st.minHeight = (H - delta) + 'px'; }
    void el.offsetHeight;
    st.transition = (on ? 'height ' : 'min-height ') + GLIDE;
    if (on) st.height = H + 'px'; else st.minHeight = H + 'px';
    setTimeout(function () { st.height = ''; st.overflow = ''; st.overflowClipMargin = ''; st.minHeight = ''; st.transition = ''; }, GLIDE_MS + 80);
  }

  /* ---------- the truth: re-read the cart if the card and the prices disagree ---------- */
  function watchHead() {
    var h = document.querySelector('[data-gcc] [data-club-toggle]');
    if (!h || h.__gcm) return; h.__gcm = 1;
    new MutationObserver(function () {
      if (h.classList.contains('is-busy') || !window.GOBClubPrices) return;
      if (root.classList.contains('gob-club-on') !== h.classList.contains('is-on') && !root.hasAttribute('data-gob-member')) GOBClubPrices.read();
    }).observe(h, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 2. entrance of the arriving prices (gob-club-motion.css) ---------- */
  function run(on) {
    root.classList.remove('gcm-in', 'gcm-out');
    void root.offsetWidth;
    root.classList.add(on ? 'gcm-in' : 'gcm-out');
    clearTimeout(timer);
    timer = setTimeout(function () { root.classList.remove('gcm-in', 'gcm-out'); }, HOLD);
  }
  document.addEventListener('gob:club-prices', function (e) {
    if (RM.matches || !document.querySelector('[data-gcc]')) return;
    run(!!(e.detail && e.detail.on));
  });

  /* ---------- Add to cart label: soft swap when its text changes ---------- */
  function watchLabel() {
    var l = document.querySelector('[data-add-to-cart-text]');
    if (!l || l.__gcm) return; l.__gcm = 1;
    var last = l.textContent;
    new MutationObserver(function () {
      if (l.textContent === last || RM.matches) return; last = l.textContent;
      l.classList.remove('gcm-lbl'); void l.offsetWidth; l.classList.add('gcm-lbl');
    }).observe(l, { childList: true, characterData: true, subtree: true });
  }

  function boot() { watchHead(); watchLabel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
